export default __webpack_public_path__ + "static/ambient365-2a5b3ca5e14845582429a05024484561.png";